/**
 * @generated SignedSource<<157e592f1782ca843bffd824483c6ee9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type userTracking_viewer$data = {
  readonly transactionsCounter?: {
    readonly confirmedTransactions: number | null;
    readonly submittedTransactions: number | null;
  } | null;
  readonly " $fragmentType": "userTracking_viewer";
};
export type userTracking_viewer$key = {
  readonly " $data"?: userTracking_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"userTracking_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasUserId"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "userTracking_viewer",
  "selections": [
    {
      "condition": "hasUserId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userId"
            }
          ],
          "concreteType": "TransactionsCounter",
          "kind": "LinkedField",
          "name": "transactionsCounter",
          "plural": false,
          "selections": [
            {
              "alias": "submittedTransactions",
              "args": null,
              "kind": "ScalarField",
              "name": "submitted",
              "storageKey": null
            },
            {
              "alias": "confirmedTransactions",
              "args": null,
              "kind": "ScalarField",
              "name": "confirmed",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "53fc982c10ec64ad7d2f7e4147b160b7";

export default node;
